import request from '@/plugins/axios'


//投稿人桌面
export function desktopEditor(params) {
  return request({
    url: '/userCenter/desktopEditor',
    method: 'get',
    params
  })
}


//获取手机url
export function getMobileUpdateUrl() {
  return request({
    url: '/userCenter/getMobileUpdateUrl',
    method: 'get'
  })
}


//获取用户的权限
export function myPowers() {
  return request({
    url: '/userCenter/myPowers',
    method: 'post'
  })
}